import React, { FunctionComponent, createElement, ReactNode } from 'react'
import clsx from 'clsx'
import styles from './typography.module.scss'

interface Props {
  children: string | ReactNode
  /** The variations the typography can render */
  variant:
    | 'h1'
    | 'h2'
    | 'h3'
    | 'h4'
    | 'h5'
    | 'h6'
    | 'subtitle'
    | 'paragraph'
    | 'paragraph-sm'
    | 'paragraph-lg'
    | 'price-lg'
    | 'price'
    | 'price-sale'
    | 'eyebrow'
    | 'byline'
  /** Can pass a custom custom tag to the component.
   * For example, this is helpful when you want the typography
   * of an h1 without it being an h1 */
  tag?: string
  /** Override styles to wrapper */
  className?: string
  /** Which way the text is aligned */
  align?: 'left' | 'center' | 'right'
  /** If true, sets the text to not wrpa and instead display elipsis */
  noWrap?: boolean
  /** Sets the color of the text */
  color?: 'primary' | 'secondary' | 'error' | 'success' | 'alert' | 'white'
  [rest: string]: unknown // ...rest property
}

const customElement = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle: 'p',
  paragraph: 'p',
  'paragraph-sm': 'p',
  'paragraph-lg': 'p',
  'price-lg': 'p',
  price: 'p',
  'price-sale': 'p',
  eyebrow: 'p',
  byline: 'p'
}

const Typography: FunctionComponent<Props> = ({ variant, children, className, tag, align, noWrap, color, ...rest }) => {
  let textStyles = clsx(
    styles.wrapper,
    align && styles[align],
    noWrap && styles.noWrap,
    color && styles[color],
    styles[variant],
    className
  )
  return createElement(tag ? tag : customElement[variant], { className: textStyles, ...rest }, children)
}

export default Typography
